module.exports = __webpack_public_path__ + "static/img/st2.42920643.png";